var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-button",
    {
      class: _vm.useIcon ? "md-info md-just-icon md-round" : "" + _vm.className,
      attrs: { title: "Create asset log" },
      on: {
        click: function ($event) {
          $event.stopPropagation()
          return _vm.handleCreateAssetLog($event)
        },
      },
    },
    [
      _vm.useIcon
        ? _c("md-icon", [_vm._v("note_add")])
        : _c("span", [_vm._v("note_add")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }